/* KAARKASH shopping assistant — the chat window (sections/kk-chat).
   - Talks to the assistant Worker, reading its reply as it is written (server-sent events).
   - Runs the tools that belong in the browser: the bag, the delivery check and order
     tracking (the store's own tracking Worker, with its own limits), and complaints (the
     store's own contact form). Their results go back to the assistant, which carries on.
   - Keeps conversations on this device: each one is the signed state the Worker hands back,
     plus what was shown, so a conversation can be picked up again later.
   Everything the assistant writes is put on the page as text, never as HTML. */
(function () {
  'use strict';
  if (window.__kkChat) return;
  var root = document.querySelector('[data-kkchat]');
  if (!root) return;
  var config;
  try { config = JSON.parse(root.querySelector('[data-kkchat-config]').textContent); } catch (e) { return; }
  if (!config.endpoint) return;

  var STORE = 'kk_chat_v1', CID = 'kk_chat_cid';
  var MAX_CONVOS = 12, MAX_ENTRIES = 160;
  var KEEP_MS = 30 * 24 * 3600 * 1000;   // conversations are kept for 30 days, on this device only
  var ROOT = config.root && config.root !== '/' ? config.root.replace(/\/$/, '') : '';
  var ENDPOINT = config.endpoint.replace(/\/$/, '');
  var TRACKING = (config.tracking || '').replace(/\/$/, '');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 749px)');
  var html = document.documentElement;

  var el = {
    launch: root.querySelector('[data-kkchat-open]'),
    panel: root.querySelector('[data-kkchat-panel]'),
    log: root.querySelector('[data-kkchat-log]'),
    hello: root.querySelector('[data-kkchat-hello]'),
    convos: root.querySelector('[data-kkchat-convos]'),
    convoList: root.querySelector('[data-kkchat-convo-list]'),
    back: root.querySelector('[data-kkchat-back]'),
    title: root.querySelector('[data-kkchat-title]'),
    list: root.querySelector('.kkchat__chats'),
    clear: root.querySelector('[data-kkchat-clear]'),
    count: root.querySelector('[data-kkchat-count]'),
    saved: root.querySelector('[data-kkchat-saved]'),
    recent: root.querySelector('[data-kkchat-recent]'),
    recentList: root.querySelector('[data-kkchat-recent-list]'),
    form: root.querySelector('[data-kkchat-form]'),
    input: root.querySelector('[data-kkchat-input]'),
    send: root.querySelector('[data-kkchat-send]'),
    announce: root.querySelector('[data-kkchat-announce]'),
    quick: root.querySelector('[data-kkchat-quick]'),
  };

  var store = load();
  var convo = currentConvo();
  var busy = false, opened = false, checked = false, lastFocus = null;
  // The chat follows a reply as it is written, unless the customer scrolls up to read.
  var follow = true, ourScroll = false;

  /* ============ storage: this device only ============ */
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (s && Array.isArray(s.convos)) {
        var cutoff = Date.now() - KEEP_MS;
        return { current: s.current, convos: s.convos.filter(function (c) { return c && c.updated > cutoff; }) };
      }
    } catch (e) { /* unreadable: start clean */ }
    return { current: null, convos: [] };
  }
  function clearAll() {
    if (busy) return;
    store = { current: null, convos: [] };
    convo = null;
    try { localStorage.removeItem(STORE); } catch (e) { /* nothing kept to remove */ }
    countChats();
    renderConvo();
    showLog();
    announce('Your conversations have been cleared from this device.');
    el.input.focus({ preventScroll: true });
  }
  function save() {
    store.convos.sort(function (a, b) { return b.updated - a.updated; });
    store.convos = store.convos.slice(0, MAX_CONVOS);
    countChats();
    for (var tries = 0; tries < 4; tries++) {
      try { localStorage.setItem(STORE, JSON.stringify(store)); return; } catch (e) {
        if (store.convos.length <= 1) return;       // full: the oldest conversation makes room
        store.convos.pop();
      }
    }
  }
  // the chats that have something in them: the number on the Chats button
  function kept() { return store.convos.filter(function (c) { return c.log && c.log.length; }); }
  function countChats() {
    if (!el.count) return;
    var n = kept().length;
    el.count.textContent = n ? String(n) : '';
    el.count.hidden = !n;
    el.list && el.list.setAttribute && el.list.setAttribute('aria-label', n ? 'Your chats (' + n + ')' : 'Your chats');
  }
  function newConvo() {
    var c = { id: 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7), title: '', updated: Date.now(), state: null, log: [], full: false };
    store.convos.unshift(c);
    store.current = c.id;
    return c;
  }
  function currentConvo() {
    var found = store.convos.filter(function (c) { return c.id === store.current; })[0];
    return found || null;
  }
  function ensureConvo() {
    if (!convo) { convo = newConvo(); save(); }
    return convo;
  }
  function record(entry, into) {
    var c = into || ensureConvo();
    c.log.push(entry);
    if (c.log.length > MAX_ENTRIES) c.log = c.log.slice(-MAX_ENTRIES);
    c.updated = Date.now();
    save();
  }
  function browserId() {
    try {
      var id = localStorage.getItem(CID);
      if (!id) { id = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem(CID, id); }
      return id;
    } catch (e) { return ''; }
  }

  /* ============ opening and closing ============ */
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    el.launch.setAttribute('aria-expanded', 'true');
    el.panel.setAttribute('aria-modal', phone.matches ? 'true' : 'false');
    if (phone.matches) { html.classList.add('kkchat-is-open'); setBehind(true); }
    if (!opened) { opened = true; renderConvo(); }
    showLog();
    // on a phone the keyboard would cover half the chat before anything is read
    if (phone.matches) el.panel.focus({ preventScroll: true });
    else el.input.focus({ preventScroll: true });
    scrollDown(true);
    healthCheck();
    track('kk_chat_open');
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    html.classList.remove('kkchat-is-open');
    setBehind(false);
    el.launch.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus) && lastFocus !== document.body) lastFocus.focus({ preventScroll: true });
    else el.launch.focus({ preventScroll: true });
  }
  // On a phone the chat is the whole screen, and what is behind it is out of reach of the
  // keyboard and of screen readers until it closes.
  var madeInert = [];
  function setBehind(on) {
    if (on) {
      Array.prototype.slice.call(document.body.children).forEach(function (n) {
        if (n.contains(root) || n.inert || n.tagName === 'SCRIPT') return;
        n.inert = true;
        madeInert.push(n);
      });
    } else {
      madeInert.forEach(function (n) { n.inert = false; });
      madeInert = [];
    }
  }
  // Is the assistant there at all? Asked once, the first time the chat opens.
  function healthCheck() {
    if (checked) return;
    checked = true;
    fetch(ENDPOINT + '/', { method: 'GET' }).then(function (r) { return r.json(); }).then(function (d) {
      if (!d || !d.configured) offline();
      else if (d.saving && el.saved) el.saved.hidden = false;      // conversations are being saved: say so
    }).catch(offline);
  }
  function offline() {
    if (root.querySelector('[data-kkchat-offline]')) return;
    var note = noteNode('Our assistant is resting just now. Our team is a message away:');
    note.setAttribute('data-kkchat-offline', '');
    el.log.appendChild(note);
    el.log.appendChild(contactNode(fallbackLinks('Hi KAARKASH, I have a question.')));
    scrollDown(true);
  }

  /* ============ showing a conversation ============ */
  function renderConvo() {
    Array.prototype.slice.call(el.log.children).forEach(function (n) { if (n !== el.hello) n.remove(); });
    var c = convo;
    el.hello.hidden = !!(c && c.log.length);
    root.classList.toggle('is-fresh', !(c && c.log.length));
    if (!c) return;
    c.log.forEach(function (entry) { var n = renderEntry(entry, true); if (n) el.log.appendChild(n); });
    scrollDown(true);
  }
  function renderEntry(e, quiet) {
    switch (e.k) {
      case 'me': return meNode(e.text);
      case 'bot': return botNode(e.text, quiet);
      case 'products': return cardsNode(e.items, e.link);
      case 'product': return detailNode(e.item);
      case 'contact': return contactNode(e.links);
      case 'ticket': return ticketNode(e);
      case 'fact': return factNode(e);
      case 'note': return noteNode(e.text);
      case 'trackform': return e.done ? null : trackFormNode(e);
      default: return null;
    }
  }
  function add(node) { if (node) { el.hello.hidden = true; root.classList.remove('is-fresh'); el.log.appendChild(node); scrollDown(); } return node; }
  // What a tap brings (the bag confirmation, the size picker) is brought into view however far
  // up the customer had scrolled to tap, and glows for a moment so the eye finds it.
  function reveal(node) {
    if (!node) return;
    follow = true;
    ourScroll = true;
    try { el.log.scrollTo({ top: el.log.scrollHeight, behavior: reduce.matches ? 'auto' : 'smooth' }); }
    catch (e) { el.log.scrollTop = el.log.scrollHeight; }
    setTimeout(function () { ourScroll = false; }, 700);
    node.classList.add('is-new');
    setTimeout(function () { node.classList.remove('is-new'); }, 1800);
  }
  function scrollDown(now) {
    if (!now && !follow) return;
    if (now) follow = true;
    ourScroll = true;
    el.log.scrollTop = el.log.scrollHeight;
    requestAnimationFrame(function () { ourScroll = false; });
  }

  /* ============ nodes ============ */
  function make(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function meNode(text) {
    var wrap = make('div', 'kkchat__msg kkchat__msg--me');
    wrap.appendChild(make('div', 'kkchat__me', text));
    return wrap;
  }
  function avatarNode() {
    var a = make('span', 'kkchat__avatar', 'K');
    a.setAttribute('aria-hidden', 'true');
    return a;
  }
  function botNode(text, quiet) {
    var wrap = make('div', 'kkchat__msg kkchat__msg--bot');
    var body = make('div', 'kkchat__bot');
    paint(body, text);
    wrap.appendChild(avatarNode());
    wrap.appendChild(body);
    if (quiet) wrap.style.animation = 'none';
    return wrap;
  }
  // A little of markdown, built as nodes: **bold**, "- " lists and paragraphs. Never HTML.
  function paint(target, text) {
    target.textContent = '';
    var blocks = String(text || '').replace(/\r/g, '').split(/\n{2,}/);
    blocks.forEach(function (block) {
      var lines = block.split('\n').filter(function (l) { return l.trim() !== ''; });
      if (!lines.length) return;
      var list = null, para = null;
      lines.forEach(function (line) {
        var item = /^\s*(?:[-•*]|\d+[.)])\s+(.*)$/.exec(line);
        if (item) {
          if (!list) { list = make('ul'); target.appendChild(list); para = null; }
          var li = make('li'); inline(li, item[1]); list.appendChild(li);
        } else {
          list = null;
          if (!para) { para = make('p'); target.appendChild(para); } else para.appendChild(document.createElement('br'));
          inline(para, line.trim());
        }
      });
    });
  }
  function inline(target, text) {
    var parts = String(text).split(/(\*\*[^*]+\*\*)/g);
    parts.forEach(function (p) {
      if (/^\*\*[^*]+\*\*$/.test(p)) target.appendChild(make('strong', null, p.slice(2, -2)));
      else if (p) target.appendChild(document.createTextNode(p.replace(/\*\*/g, '')));
    });
  }
  function noteNode(text) { return make('p', 'kkchat__note', text); }
  // For screen readers: what appeared, said once. The same words twice are said twice.
  function announce(text) {
    el.announce.textContent = '';
    setTimeout(function () { el.announce.textContent = text; }, 60);
  }
  function announceEntry(e) {
    if (e.k === 'products') announce((e.items || []).length + ' products shown: ' + (e.items || []).map(function (p) { return p.title + ', ' + p.price; }).join('; '));
    else if (e.k === 'product') announce('Product: ' + e.item.title + ', ' + e.item.price);
    else if (e.k === 'contact') announce('Buttons to reach our team on WhatsApp or by email are shown.');
    else if (e.k === 'fact') announce([e.label].concat(e.lines || []).join('. '));
    else if (e.k === 'ticket' && e.ticket) announce('Ticket ' + e.ticket.number + ': ' + e.ticket.status + (e.ticket.answer ? '. Our answer: ' + e.ticket.answer : e.ticket.due_text ? '. We will answer by ' + e.ticket.due_text : ''));
  }
  function workingNode(text) {
    var w = make('div', 'kkchat__working');
    w.setAttribute('aria-hidden', 'true');
    w.appendChild(avatarNode());
    var dots = make('span', 'kkchat__typing');
    for (var i = 0; i < 3; i++) dots.appendChild(make('span'));
    w.appendChild(dots);
    if (text) w.appendChild(make('span', 'kkchat__working-text', text));
    return w;
  }
  function tickSvg() {
    return '<svg viewBox="0 0 21 20" fill="none" aria-hidden="true" focusable="false"><rect class="kkchat__disc" x=".75" y=".5" width="19.5" height="19" rx="9.5" stroke="currentColor" stroke-width="1"/><path class="kkchat__tick" d="m6.5 10.2 2.7 2.6 5.3-5.6" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  function plusSvg() {
    return '<svg viewBox="0 0 21 20" fill="none" aria-hidden="true" focusable="false"><rect class="kkchat__disc" x=".75" y=".5" width="19.5" height="19" rx="9.5" stroke="currentColor" stroke-width="1"/><path class="kkchat__plus" d="M10.5 5.5v9M6 10h9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  }
  function image(src, alt) {
    var img = document.createElement('img');
    img.alt = alt || '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.addEventListener('load', function () { img.classList.add('is-in'); }, { once: true });
    img.addEventListener('error', function () { img.remove(); }, { once: true });
    if (/^https:\/\//.test(src || '')) img.src = src;
    return img;
  }
  function cardsNode(items, link) {
    var row = make('div', 'kkchat__cards');
    row.setAttribute('role', 'list');
    (items || []).forEach(function (p) {
      var card = make('div', 'kkchat__card');
      card.setAttribute('role', 'listitem');
      var a = make('a', 'kkchat__card-link');
      a.href = safePath(p.url);
      var media = make('span', 'kkchat__card-media');
      if (p.image) media.appendChild(image(p.image, ''));
      if (!p.in_stock) media.appendChild(make('span', 'kkchat__card-badge', 'Sold out'));
      a.appendChild(media);
      var info = make('span', 'kkchat__card-info');
      info.appendChild(make('span', 'kkchat__card-name', p.title));
      info.appendChild(priceNode('kkchat__card-price', p.price, p.was));
      a.appendChild(info);
      card.appendChild(a);
      if (p.in_stock) {
        var plus = make('button', 'kkchat__card-add');
        plus.type = 'button';
        plus.setAttribute('aria-label', 'Add ' + p.title + ' to bag');
        plus.innerHTML = plusSvg();
        plus.addEventListener('click', function () { quickAdd(p, plus); });
        card.appendChild(plus);
      }
      row.appendChild(card);
    });
    if (link) {
      var more = make('a', 'kkchat__more', 'See all');
      more.href = safePath(link);
      row.appendChild(more);
    }
    row.querySelectorAll('img').forEach(function (img) { if (img.complete && img.naturalWidth) img.classList.add('is-in'); });
    return row;
  }
  function priceNode(cls, price, was) {
    var n = make('span', cls + (was ? ' ' + cls + '--sale' : ''), price || '');
    if (was) n.appendChild(make('s', null, was));
    return n;
  }
  // One product, its options to choose from, and a button to add the one chosen.
  function detailNode(p) {
    var box = make('div', 'kkchat__detail');
    var media = make('a', 'kkchat__detail-media');
    media.href = safePath(p.url);
    media.setAttribute('aria-hidden', 'true');
    media.tabIndex = -1;
    if (p.image) media.appendChild(image(p.image, ''));
    box.appendChild(media);
    var side = make('div');
    var name = make('p', 'kkchat__detail-name');
    var link = make('a', null, p.title);
    link.href = safePath(p.url);
    name.appendChild(link);
    side.appendChild(name);
    side.appendChild(priceNode('kkchat__card-price', p.price, p.was));
    var variants = (p.variants || []).filter(Boolean);
    var chosen = null;
    var addBtn = make('button', 'kkchat__btn kkchat__btn--solid', p.in_stock ? 'Add to bag' : 'Sold out');
    addBtn.type = 'button';
    var single = variants.length === 1 || variants.every(function (v) { return /default title/i.test(v.title || ''); });
    if (single) chosen = variants.filter(function (v) { return v.in_stock; })[0] || null;
    else {
      var opts = make('div', 'kkchat__options');
      opts.setAttribute('role', 'group');
      opts.setAttribute('aria-label', 'Options');
      variants.forEach(function (v) {
        var b = make('button', 'kkchat__option', v.title);
        b.type = 'button';
        b.disabled = !v.in_stock;
        b.setAttribute('aria-pressed', 'false');
        if (!v.in_stock) b.setAttribute('aria-label', v.title + ', sold out');
        b.addEventListener('click', function () {
          chosen = v;
          opts.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          addBtn.disabled = false;
        });
        opts.appendChild(b);
      });
      side.appendChild(opts);
    }
    addBtn.disabled = !chosen;
    addBtn.addEventListener('click', function () {
      if (!chosen) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      addToBag({ variant_id: chosen.id, quantity: 1 }, convo).then(function (res) {
        addBtn.textContent = res.ok ? 'In your bag' : 'Add to bag';
        if (!res.ok) addBtn.disabled = false;
        if (res.ok && box.__kkCardButton) cardAdded(box.__kkCardButton);
        showBagFact(res);
      }).catch(function () { addBtn.textContent = 'Add to bag'; addBtn.disabled = false; showBagFact({ ok: false }); });
    });
    var actions = make('div', 'kkchat__actions');
    actions.style.margin = '0';
    actions.appendChild(addBtn);
    side.appendChild(actions);
    box.appendChild(side);
    return box;
  }
  function buttonLink(label, href, solid, newTab) {
    var a = make('a', 'kkchat__btn' + (solid ? ' kkchat__btn--solid' : ''), label);
    a.href = safeHref(href);
    if (newTab) { a.target = '_blank'; a.rel = 'noopener'; }
    return a;
  }
  function contactNode(links) {
    var row = make('div', 'kkchat__actions');
    if (links && links.whatsapp) {
      var wa = buttonLink('WhatsApp us', links.whatsapp, true, true);
      wa.addEventListener('click', function () { track('kk_chat_handoff', { channel: 'whatsapp' }); });
      row.appendChild(wa);
    }
    if (links && links.email) {
      var em = buttonLink('Email us', links.email, false, false);
      em.addEventListener('click', function () { track('kk_chat_handoff', { channel: 'email' }); });
      row.appendChild(em);
    }
    return row;
  }
  function factNode(f) {
    var box = make('div', 'kkchat__fact' + (f.ok ? ' kkchat__fact--ok' : ''));
    if (f.label) {
      var label = make('span', 'kkchat__fact-label');
      if (f.ok) label.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="m2 6.5 2.6 2.5L10 3.5"/></svg>');
      label.appendChild(document.createTextNode(f.label));
      box.appendChild(label);
    }
    (f.lines || []).forEach(function (line, i) {
      var p = make('p', null);
      p.style.margin = '0';
      if (i === 0 && f.strong) p.appendChild(make('strong', null, line)); else p.textContent = line;
      box.appendChild(p);
    });
    if (f.buttons && f.buttons.length) {
      var row = make('div', 'kkchat__actions');
      f.buttons.forEach(function (b) {
        if (b.action === 'bag') {
          var btn = make('button', 'kkchat__btn' + (b.solid ? ' kkchat__btn--solid' : ''), b.label);
          btn.type = 'button';
          btn.addEventListener('click', openBag);
          row.appendChild(btn);
        } else row.appendChild(buttonLink(b.label, b.href, b.solid, b.newTab));
      });
      box.appendChild(row);
    }
    return box;
  }
  // Only a path on this site: no "//other.site", no backslashes or control characters that
  // a browser would read as one.
  function safePath(p) { return typeof p === 'string' && /^\/(?![\/\\])/.test(p) && !/[\\\u0000-\u001f]/.test(p) ? ROOT + p : ROOT + '/'; }
  // A link in the conversation may go to this site, to WhatsApp or to an email, nowhere else.
  function safeHref(h) {
    h = String(h || '');
    if (/^https:\/\/wa\.me\/\d+(\?|$)/.test(h) || /^mailto:[^\s<>"]+$/.test(h)) return h;
    if (/^\//.test(h)) return safePath(h.slice(ROOT.length && h.indexOf(ROOT) === 0 ? ROOT.length : 0));
    return ROOT + '/';
  }
  function fallbackLinks(text) {
    var msg = encodeURIComponent(text || 'Hi KAARKASH, I need help.');
    return {
      whatsapp: config.whatsapp ? 'https://wa.me/' + config.whatsapp + '?text=' + msg : null,
      email: config.email ? 'mailto:' + config.email + '?subject=' + encodeURIComponent('Help with my KAARKASH order') + '&body=' + msg : null,
    };
  }

  /* ============ talking to the assistant ============ */
  function say(text) {
    text = String(text || '').trim();
    if (!text || busy) return;
    var c = ensureConvo();
    if (c.full) { convo = newConvo(); save(); renderConvo(); c = convo; }
    if (!c.title) c.title = text.length > 48 ? text.slice(0, 47) + '…' : text;
    add(meNode(text));
    scrollDown(true);
    record({ k: 'me', text: text });
    el.input.value = '';
    sizeInput();
    track('kk_chat_message');
    if (wantsPerson(text)) { offerPerson(text); return; }
    ask({ message: text }, true);
  }
  // Asked for WhatsApp, a call or a person (owner, 2026-10-13: "keep it at a quick tap"): the
  // buttons come at once, with no wait for the assistant. Not when the message carries a phone
  // number or an email — that is an answer to a question, for the assistant.
  var PERSON = /whats\s*app|\b(talk|speak|chat|baat)\s+(to|with|karni|karna|karo|karwao)\b|\b(human|real person|live agent|an agent|customer care|helpline|call ?back|call me)\b|\b(number|contact)\s+(do|dedo|dijiye|bhejo|chahiye)\b/i;
  function wantsPerson(text) { return text.length < 160 && !/\d{8,}|@/.test(text) && PERSON.test(text); }
  function offerPerson(text) {
    var links = fallbackLinks('Hi KAARKASH — ' + text);
    if (!links.whatsapp && !links.email) { ask({ message: text }, true); return; }
    var line = 'Sure — tap below to reach our team on WhatsApp' + (links.email ? ' or by email' : '') + '; they reply during working hours. Or tell me what you need and I will help right here.';
    add(botNode(line, false));
    record({ k: 'bot', text: line });
    add(contactNode(links));
    record({ k: 'contact', links: links });
    announce(line);
    track('kk_chat_person_asked');
  }

  function ask(payload, mayRetry) {
    busy = true;
    syncSend();
    var target = convo;              // the reply belongs here, whatever is on screen by then
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 90000) : 0;
    var gotState = false;
    var working = add(workingNode(payload.toolResults ? '' : 'Thinking…'));
    var page = { path: location.pathname, title: config.pageTitle || document.title.split('–')[0].split('|')[0].trim() };
    var mine = savedTickets().slice(0, 5).map(function (t) { return { number: t.number, contact: t.contact }; });
    if (mine.length) page.tickets = mine;
    if (config.who) page.who = config.who;      // signed in: the assistant can read their own rewards
    if (target.order) page.order = target.order;  // an order found with the chat's own form (trackForm)
    var body = { state: target.state || undefined, page: page };
    if (payload.message) body.message = payload.message;
    if (payload.toolResults) body.toolResults = payload.toolResults;

    var bubble = null, text = '', actions = null, pendingFrame = 0;
    function flushText() {
      pendingFrame = 0;
      if (!bubble) return;
      var said = bubble.querySelector('.kkchat__bot');
      paint(said, text);
      said.appendChild(make('span', 'kkchat__caret'));
      scrollDown();
    }
    function closeText() {
      if (!bubble) return;
      paint(bubble.querySelector('.kkchat__bot'), text);
      if (text.trim()) {
        record({ k: 'bot', text: text }, target);
        announce(text.replace(/\*\*/g, ''));
      } else bubble.remove();
      bubble = null;
      text = '';
    }
    function onEvent(e) {
      if (e.type === 'text') {
        if (working) { working.remove(); working = null; }
        if (!bubble) { bubble = add(botNode('', false)); }
        text += e.delta;
        if (!pendingFrame) pendingFrame = requestAnimationFrame(flushText);
        return;
      }
      if (e.type === 'products' || e.type === 'product' || e.type === 'contact' || e.type === 'ticket') {
        closeText();
        var entry = e.type === 'products' ? { k: 'products', items: e.items, link: e.link } : e.type === 'product' ? { k: 'product', item: e.item } : e.type === 'ticket' ? { k: 'ticket', ticket: e.ticket } : { k: 'contact', links: e.links };
        add(renderEntry(entry));
        record(entry, target);
        announceEntry(entry);
        return;
      }
      if (e.type === 'meta') { if (e.id) target.sid = String(e.id); target.save = !!e.save; return; }
      if (e.type === 'actions') { actions = e.calls; return; }
      if (e.type === 'state') { target.state = e.state; target.updated = Date.now(); gotState = true; save(); return; }
      if (e.type === 'full') { target.full = true; save(); return; }
      if (e.type === 'error') {
        closeText();
        if (working) { working.remove(); working = null; }
        var msg = e.message || 'Something went wrong on our side.';
        add(noteNode(msg));
        record({ k: 'note', text: msg }, target);
        announce(msg);
        return;
      }
    }

    return fetch(ENDPOINT + '/chat?cid=' + encodeURIComponent(browserId()), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller ? controller.signal : undefined,
    }).then(function (res) {
      if (res.status === 409 && mayRetry && payload.message) {
        // The conversation could not be picked up (too long, or signed with an old key):
        // a fresh one starts on the server, the customer is told, and the message goes again.
        if (working) working.remove();
        clearTimeout(timer);
        target.state = null;
        target.full = false;
        save();
        var fresh = 'Our earlier conversation was too long to carry on, so I’m starting fresh from here.';
        add(noteNode(fresh));
        record({ k: 'note', text: fresh }, target);
        busy = false;
        return ask(payload, false);
      }
      if (res.status === 429) {
        return res.json().catch(function () { return {}; }).then(function (d) {
          // a step half way through is sent again once, a moment later; the server closes
          // any step that never arrives, so nothing stays stuck
          if (payload.toolResults && mayRetry !== 'retried') {
            if (working) working.remove();
            clearTimeout(timer);
            busy = false;
            return new Promise(function (r) { setTimeout(r, 4000); }).then(function () { return ask(payload, 'retried'); });
          }
          fail('You are sending messages very quickly — please wait ' + (d.retryAfterSec || 30) + ' seconds.', false);
        });
      }
      if (res.status === 503) {
        return res.json().catch(function () { return {}; }).then(function (d) {
          fail(d.error === 'resting' ? 'Our assistant is resting for today. Our team is a message away:' : null, true);
        });
      }
      if (!res.ok || !res.body) { fail(null, true); return; }
      return readEvents(res.body, onEvent).then(function () {
        clearTimeout(timer);
        if (pendingFrame) cancelAnimationFrame(pendingFrame);
        closeText();
        if (working) { working.remove(); working = null; }
        if (!gotState) { fail('The reply was cut short. Please send your message again.', false); return; }
        busy = false;
        syncSend();
        if (payload.message) markCart(target);
        if (actions && actions.length) return runActions(actions, target);
      });
    }).catch(function () { clearTimeout(timer); fail(null, true); }).then(function () {
      if (working) working.remove();
      busy = false;
      syncSend();
    });

    function fail(message, offerTeam) {
      if (working) { working.remove(); working = null; }
      closeText();
      var text = message || 'I couldn’t reach our assistant just now. Try again in a moment, or reach our team directly:';
      add(noteNode(text));
      record({ k: 'note', text: text }, target);
      announce(text);
      if (offerTeam) {
        var links = fallbackLinks(payload.message ? 'Hi KAARKASH — ' + payload.message : '');
        add(contactNode(links));
        record({ k: 'contact', links: links }, target);
      }
    }
  }

  function readEvents(stream, onEvent) {
    var reader = stream.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    function pump() {
      return reader.read().then(function (r) {
        if (r.done) return;
        buffer += decoder.decode(r.value, { stream: true });
        var cut;
        while ((cut = buffer.indexOf('\n\n')) >= 0) {
          var block = buffer.slice(0, cut);
          buffer = buffer.slice(cut + 2);
          if (block.indexOf('data: ') !== 0) continue;
          var e;
          try { e = JSON.parse(block.slice(6)); } catch (err) { continue; }
          onEvent(e);
        }
        return pump();
      });
    }
    return pump();
  }

  /* ============ tools that run here ============ */
  var WORKING = {
    add_to_bag: 'Adding to your bag…',
    view_bag: 'Looking at your bag…',
    check_delivery: 'Checking delivery…',
    track_order: 'Finding your order…',
    raise_ticket: 'Raising your ticket…',
  };
  function runActions(calls, target) {
    busy = true;
    syncSend();
    var results = [];
    return calls.reduce(function (prev, call) {
      return prev.then(function () {
        var working = add(workingNode(WORKING[call.name] || 'One moment…'));
        return runTool(call, target).then(function (out) {
          working.remove();
          results.push({ id: call.id, content: out });
        });
      });
    }, Promise.resolve()).then(function () {
      busy = false;
      // the results go to the conversation that asked for them
      if (convo !== target) { convo = target; store.current = target.id; save(); renderConvo(); }
      return ask({ toolResults: results }, true);
    });
  }
  function runTool(call, target) {
    var a = call.args || {};
    var job;
    switch (call.name) {
      case 'add_to_bag': job = addToBag(a, target).then(function (res) { showBagFact(res); return res; }); break;
      case 'view_bag': job = viewBag(); break;
      case 'check_delivery': job = checkDelivery(a.pincode); break;
      case 'track_order': job = trackOrder(a.contact, a.order_number); break;
      case 'raise_ticket': job = raiseTicket(a); break;
      default: job = Promise.resolve({ error: 'unknown_tool' });
    }
    return job.catch(function () { return { error: 'failed', note: 'This could not be done from the chat just now.' }; });
  }

  function cartSections() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
  }
  // The bag, brought up to date where it sits: nothing opens over the chat.
  function refreshCart(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!sections) return;
    if (drawer && drawer.getSectionsToRender && drawer.getSectionInnerHTML) {
      drawer.classList.remove('is-empty');
      drawer.getSectionsToRender().forEach(function (part) {
        var target = part.selector ? document.querySelector(part.selector) : document.getElementById(part.id);
        if (target && sections[part.id]) target.innerHTML = drawer.getSectionInnerHTML(sections[part.id], part.selector);
      });
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
    } else if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
    }
  }
  function addToBag(a, from) {
    var id = Number(a.variant_id), qty = Math.min(5, Math.max(1, Number(a.quantity) || 1));
    return fetch(ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: cartSections(), sections_url: location.pathname }),
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) return { ok: false, error: (d && (d.description || d.message)) || 'could_not_add' };
        refreshCart(d.sections);
        var item = (d.items && d.items[0]) || {};
        track('kk_chat_add_to_bag', { variant_id: id });
        markCart(from, id);
        return fetch(ROOT + '/cart.js').then(function (c) { return c.json(); }).then(function (cart) {
          return { ok: true, added: item.product_title || item.title, option: item.variant_title || null, quantity: qty, bag_count: cart.item_count, bag_total: money(cart.total_price) };
        }).catch(function () { return { ok: true, added: item.product_title || item.title, quantity: qty }; });
      });
    });
  }
  // Chat sales. While the store saves conversations (the Worker says so in each reply's meta),
  // the cart carries the conversations it came through (kk_chat, newest first) and the pieces
  // the chat put in it (kk_chat_added). The order inherits both; the Worker tags it chat-sale
  // or chat-assisted from them. One change at a time, so two never undo each other.
  var marking = Promise.resolve();
  function markCart(c, variantId) {
    if (!c || !c.save || !/^[0-9a-f]{32}$/.test(c.sid || '')) return marking;
    marking = marking.then(function () {
      return fetch(ROOT + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var a = (cart && cart.attributes) || {};
        var ids = String(a.kk_chat || '').split(/\s+/).filter(function (x) { return x && x !== c.sid; });
        ids.unshift(c.sid);
        // only what is still in the bag: a piece taken out and later bought some other way is no chat sale
        var inBag = ((cart && cart.items) || []).map(function (i) { return String(i.variant_id); });
        var added = String(a.kk_chat_added || '').split(/\s+/).filter(function (x) { return x && inBag.indexOf(x) >= 0; });
        if (variantId && added.indexOf(String(variantId)) < 0) added.push(String(variantId));
        var next = { kk_chat: ids.slice(0, 3).join(' '), kk_chat_added: added.slice(-20).join(' ') };
        if (next.kk_chat === (a.kk_chat || '') && next.kk_chat_added === (a.kk_chat_added || '')) return;
        return fetch(ROOT + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: next }) });
      });
    }).catch(function () { /* the sale goes untagged; the customer's bag is untouched */ });
    return marking;
  }
  function showBagFact(res) {
    var entry = res.ok
      ? { k: 'fact', ok: true, label: 'Added to your bag', strong: true, lines: [(res.added || 'Your piece') + (res.option ? ' — ' + res.option : ''), res.bag_count ? res.bag_count + ' in your bag · ' + res.bag_total : ''].filter(Boolean),
          buttons: [{ label: 'View bag', action: 'bag' }, { label: 'Checkout', href: ROOT + (config.checkoutUrl || '/checkout'), solid: true }] }
      : { k: 'fact', label: 'Could not add', lines: [res.error || 'Please try again.'] };
    reveal(add(renderEntry(entry)));
    record(entry);
    announceEntry(entry);
  }
  function openBag() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.open) { close(); drawer.open(); }
    else location.href = config.cartUrl || '/cart';
  }
  function viewBag() {
    return fetch(ROOT + '/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart.items || []).slice(0, 12).map(function (i) { return { title: i.product_title, option: i.variant_title, quantity: i.quantity, price: money(i.final_line_price) }; });
      var entry = { k: 'fact', label: 'Your bag', lines: cart.item_count ? items.map(function (i) { return i.quantity + ' × ' + i.title + (i.option ? ' — ' + i.option : '') + ' · ' + i.price; }).concat(['Total ' + money(cart.total_price)]) : ['Your bag is empty.'],
        buttons: cart.item_count ? [{ label: 'View bag', action: 'bag' }, { label: 'Checkout', href: ROOT + (config.checkoutUrl || '/checkout'), solid: true }] : [] };
      add(renderEntry(entry));
      record(entry);
      return { count: cart.item_count, total: money(cart.total_price), items: items };
    });
  }
  function checkDelivery(pin) {
    if (!TRACKING) return Promise.resolve({ error: 'not_available' });
    return fetch(TRACKING + '/?pin=' + encodeURIComponent(pin) + '&cid=' + encodeURIComponent(browserId())).then(function (r) { return r.json(); }).then(function (d) {
      if (d.error) return { pincode: pin, error: d.error };
      var out = { pincode: pin, deliverable: !!d.deliverable, cod: !!d.cod, prepaid: !!d.prepaid, place: [d.district, d.state].filter(Boolean).join(', ') || null };
      var entry = { k: 'fact', label: 'Delivery to ' + pin, strong: true,
        lines: out.deliverable
          ? [(out.place ? out.place + ' — ' : '') + 'we deliver here', 'Prepaid: 3–5 days by India Post · ' + (out.cod ? 'Cash on Delivery available (8–13 days)' : 'Cash on Delivery not available')]
          : ['We don’t deliver to this pincode yet'] };
      add(renderEntry(entry));
      record(entry);
      return out;
    });
  }
  function trackOrder(contact, orderNumber) {
    if (!TRACKING) return Promise.resolve({ error: 'not_available' });
    return fetch(TRACKING + '/?cid=' + encodeURIComponent(browserId()), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contact: contact, orderNumber: orderNumber || '' }),
    }).then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); }).then(function (res) {
      var d = res.d || {};
      if (d.error === 'rate_limited') return { found: false, error: 'too_many_lookups', retry_after_seconds: d.retryAfterSec };
      if (d.error === 'captcha_failed') return { found: false, error: 'use_track_page', track_page: config.trackUrl };
      if (!d.found || !d.order) {
        var miss = { k: 'fact', label: 'Order', lines: ['No order found for those details. Try the other one — the email instead of the phone, or the reverse.'], buttons: [{ label: 'Track your order page', href: ROOT + config.trackUrl }, { label: 'WhatsApp us', href: fallbackLinks('Hi KAARKASH, I cannot find my order in the chat.').whatsapp, newTab: true }].filter(function (b) { return b.href; }) };
        add(renderEntry(miss));
        record(miss);
        return { found: false };
      }
      var o = d.order;
      var t = (o.trackings || [])[0] || {};
      var live = o.live || {};
      var summary = {
        found: true, order: o.name, placed: o.createdAt ? o.createdAt.slice(0, 10) : null, payment: o.financialStatus, fulfilment: o.fulfillmentStatus,
        courier: t.company || null, tracking_number: t.number || null, status: live.status || t.status || null, location: live.location || null, expected: live.eta || live.expectedDate || null, last_update: live.updatedAt || t.updatedAt || null,
      };
      var lines = [o.name + ' · ' + String(summary.fulfilment || '').toLowerCase().replace(/_/g, ' ')];
      if (summary.status) lines.push(summary.status + (summary.location ? ' — ' + summary.location : ''));
      if (summary.expected) lines.push('Expected: ' + summary.expected);
      if (summary.tracking_number) lines.push((summary.courier ? summary.courier + ' ' : '') + summary.tracking_number);
      var buttons = [{ label: 'Full tracking', href: ROOT + config.trackUrl + (summary.tracking_number ? '?awb=' + encodeURIComponent(summary.tracking_number) : ''), solid: true }];
      var entry = { k: 'fact', label: 'Your order', strong: true, lines: lines, buttons: buttons };
      add(renderEntry(entry));
      record(entry);
      return summary;
    });
  }
  /* ============ Track my order: one tap, a small form, the store's tracking Worker ============
     Customers rarely have the courier's number (the tickets say so): the order is found by the
     phone or email used at checkout, the same lookup the assistant makes, with nothing to type
     but that. What was typed never goes in the log; the order found is told to the assistant
     (page.order) so "where is it stuck?" needs no asking again. */
  function trackForm() {
    if (busy) return;
    var c = ensureConvo();
    if (c.full) { convo = newConvo(); save(); renderConvo(); c = convo; }
    if (!c.title) c.title = 'Track my order';
    add(meNode('Track my order'));
    record({ k: 'me', text: 'Track my order' });
    var entry = { k: 'trackform' };
    var node = add(renderEntry(entry));
    record(entry);
    scrollDown(true);
    track('kk_chat_track_open');
    if (node && !phone.matches) node.querySelector('input').focus({ preventScroll: true });
  }
  var formSeq = 0;
  function trackFormNode(entry) {
    var box = make('form', 'kkchat__mini');
    box.setAttribute('data-kkchat-trackform', '');
    box.appendChild(make('p', 'kkchat__mini-text', 'Let’s find your order. Which phone number or email did you use at checkout?'));
    var id = 'KkTrack' + (++formSeq);
    var l1 = make('label', null, 'Phone number or email'); l1.htmlFor = id + 'c';
    var contact = document.createElement('input'); contact.type = 'text'; contact.id = id + 'c'; contact.name = 'contact'; contact.autocomplete = 'tel'; contact.placeholder = '98765 43210 or you@example.com'; contact.maxLength = 120; contact.required = true;
    var l2 = make('label', null, 'Order number (optional)'); l2.htmlFor = id + 'o';
    var order = document.createElement('input'); order.type = 'text'; order.id = id + 'o'; order.name = 'order'; order.autocomplete = 'off'; order.placeholder = '#2967'; order.maxLength = 20;
    var err = make('p', 'kkchat__mini-err', '');
    var btn = make('button', 'kkchat__btn kkchat__btn--solid', 'Find my order'); btn.type = 'submit';
    [l1, contact, l2, order, err, btn].forEach(function (n) { box.appendChild(n); });
    function wait(on) { btn.disabled = on; busy = on; syncSend(); if (window.kkBusy) window.kkBusy(btn, on); }
    box.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;
      var who = contact.value.trim(), digits = who.replace(/\D/g, '');
      var ok = who.indexOf('@') > -1 ? /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(who) : (digits.length >= 10 && digits.length <= 13);
      if (!ok) { err.textContent = 'Please enter the 10-digit phone number or the email used at checkout.'; contact.focus(); return; }
      err.textContent = '';
      wait(true);
      trackOrder(who.indexOf('@') > -1 ? who : digits, order.value.trim().replace(/^#/, '')).then(function (res) {
        wait(false);
        if (res && res.found) {
          entry.done = true;
          if (convo) convo.order = [res.order, String(res.fulfilment || '').toLowerCase().replace(/_/g, ' '), res.status, res.courier, res.expected ? 'expected ' + res.expected : ''].filter(Boolean).join(', ').slice(0, 160);
          save();
          box.remove();
          track('kk_chat_track_found');
          return;
        }
        if (res && res.error === 'too_many_lookups') err.textContent = 'Too many lookups just now — please try again in ' + (res.retry_after_seconds || 60) + ' seconds.';
        else if (res && res.error === 'use_track_page') err.textContent = 'Please use the Track your order page for this one.';
        else if (res && res.error === 'not_available') err.textContent = 'Tracking is not available in the chat just now — the Track your order page has it.';
        track('kk_chat_track_miss');
      }).catch(function () { wait(false); err.textContent = 'That didn’t work just now. Please try again.'; });
    });
    return box;
  }
  // A complaint goes to the team through the store's own contact form (when there is an
  // email to reply to), and always with WhatsApp and email ready, with the ticket in them —
  // a damage claim needs the unboxing video, which only those can carry.
  /* ============ tickets ============
     A ticket is raised with the assistant Worker (POST /ticket), which files it in Shopify and
     gives back its number and the date the team will answer by. The team then hears of it by
     email: the shop's own contact form, posted from here, so a reply goes to the customer.
     The customer's tickets are kept on this device (kk_tickets, shared with the Contact page)
     so "what's my ticket status" needs no number. */
  var TICKETS = 'kk_tickets';
  function savedTickets() {
    try {
      var list = JSON.parse(localStorage.getItem(TICKETS) || '[]');
      // kept sixty days: a shared device does not hold someone's tickets for ever
      var since = Date.now() - 60 * 24 * 3600 * 1000;
      return Array.isArray(list) ? list.filter(function (t) { return t && /^KK-\d{4,7}$/.test(t.number) && t.contact && (t.at || 0) > since; }) : [];
    } catch (e) { return []; }
  }
  function keepTicket(t) {
    var list = savedTickets().filter(function (x) { return x.number !== t.number; });
    list.unshift(t);
    try { localStorage.setItem(TICKETS, JSON.stringify(list.slice(0, 10))); } catch (e) { /* kept for this visit only */ }
  }
  function raiseTicket(a) {
    return fetch(ENDPOINT + '/ticket?cid=' + encodeURIComponent(browserId()), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(a),
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || !res.d.ticket) throw new Error(res.d.error || 'failed');
        var t = res.d.ticket;
        keepTicket({ number: t.number, contact: a.email || a.phone, topic: t.topic, due_text: t.due_text, at: Date.now() });
        var notify = res.d.notify ? postContactForm({ name: res.d.notify.name, contact: res.d.notify.email }, res.d.notify.body) : Promise.resolve(false);
        return notify.then(function (emailed) {
          var video = a.topic === 'damaged' || a.topic === 'wrong_item';
          var entry = { k: 'ticket', video: video, ticket: { number: t.number, status: 'New', status_text: 'We have it, and our team will look at it shortly.', topic: t.topic, due_text: t.due_text, open: true, raised: true, reply_to: a.email || a.phone } };
          reveal(add(renderEntry(entry)));
          record(entry);
          announceEntry(entry);
          showRecent();
          track('kk_chat_ticket', { topic: a.topic });
          return { ok: true, ticket_number: t.number, answer_by: t.due_text, reply_by: a.email ? 'email to ' + a.email : 'phone or WhatsApp on ' + a.phone, team_emailed: emailed, video_needed: video };
        });
      })
      .catch(function () {
        // the ticket desk could not be reached: the customer still reaches the team directly
        var lines = ['Name: ' + a.name, a.email ? 'Email: ' + a.email : null, a.phone ? 'Phone: ' + a.phone : null, a.order_number ? 'Order: #' + a.order_number : null, a.message].filter(Boolean);
        var links = fallbackLinks('Hi KAARKASH — ' + lines.join('\n'));
        var entry = { k: 'fact', label: 'Send it to our team', lines: ['Our ticket desk could not be reached just now. Tap below to send this to us directly.'],
          buttons: [{ label: 'WhatsApp us', href: links.whatsapp, solid: true, newTab: true }, { label: 'Email us', href: links.email }].filter(function (b) { return b.href; }) };
        add(renderEntry(entry));
        record(entry);
        return { ok: false, error: 'ticket_desk_unreachable', note: 'It was not raised. Tell the customer to tap WhatsApp or Email to send it to the team.' };
      });
  }
  function ticketNode(e) {
    var t = e.ticket || {};
    var box = make('div', 'kkchat__ticket' + (t.open === false ? ' is-closed' : ''));
    var head = make('div', 'kkchat__ticket-head');
    head.appendChild(make('span', 'kkchat__ticket-label', t.raised ? 'Ticket raised' : 'Your ticket'));
    head.appendChild(make('span', 'kkchat__ticket-status kkchat__ticket-status--' + String(t.status || 'new').toLowerCase().replace(/[^a-z]+/g, '-'), t.status || 'New'));
    box.appendChild(head);
    box.appendChild(make('p', 'kkchat__ticket-number', t.number || ''));
    if (t.topic) box.appendChild(make('p', 'kkchat__ticket-topic', t.topic));
    if (t.answer) {
      var ans = make('div', 'kkchat__ticket-answer');
      ans.appendChild(make('span', 'kkchat__ticket-answer-label', 'Our answer'));
      ans.appendChild(make('p', null, t.answer));
      box.appendChild(ans);
    } else if (t.open !== false && t.due_text) {
      box.appendChild(make('p', 'kkchat__ticket-due', t.overdue ? 'This was due ' + t.due_text + ' — we have flagged it to the team.' : 'We\u2019ll answer by ' + t.due_text + (t.reply_to && /@/.test(t.reply_to) ? ', by email to ' + t.reply_to : '') + '.'));
    } else if (t.status_text) box.appendChild(make('p', 'kkchat__ticket-due', t.status_text));
    var row = make('div', 'kkchat__actions');
    var copy = make('button', 'kkchat__btn', 'Copy number');
    copy.type = 'button';
    copy.addEventListener('click', function () {
      try { navigator.clipboard.writeText(t.number); } catch (err) { /* the number is on screen */ }
      copy.textContent = 'Copied';
      setTimeout(function () { copy.textContent = 'Copy number'; }, 1500);
    });
    row.appendChild(copy);
    if (e.video && t.open !== false) {
      var links = fallbackLinks('Hi KAARKASH — ticket ' + t.number + ': here is my unboxing video.');
      if (links.whatsapp) row.appendChild(buttonLink('Send video on WhatsApp', links.whatsapp, true, true));
    } else {
      row.appendChild(buttonLink('Track it', ROOT + '/pages/contact?ticket=' + encodeURIComponent(t.number) + '#help', false, false));
    }
    box.appendChild(row);
    return box;
  }
  function postContactForm(a, body) {
    var form = new URLSearchParams();
    form.set('form_type', 'contact');
    form.set('utf8', '✓');
    form.set('contact[name]', a.name);
    form.set('contact[email]', a.contact);
    form.set('contact[body]', body);
    var sent = fetch(ROOT + '/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: form.toString(), redirect: 'follow' })
      .then(function (r) { return r.ok && /contact_posted=true/.test(r.url); })
      .catch(function () { return false; });
    // a ticket is already filed in Shopify: the customer never waits on the email for long
    return Promise.race([sent, new Promise(function (r) { setTimeout(function () { r(false); }, 6000); })]);
  }
  function money(cents) {
    var n = Number(cents || 0) / 100;
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }
  // Card "+": a piece with nothing to choose is added at once; otherwise its options appear.
  function cardAdded(button) {
    button.classList.remove('is-busy');
    button.classList.add('is-done');
    button.innerHTML = tickSvg();
    button.setAttribute('aria-label', 'Added to your bag');
    var card = button.closest('.kkchat__card');
    if (card && !card.querySelector('.kkchat__card-added')) {
      var tag = make('span', 'kkchat__card-added', 'Added');
      tag.setAttribute('aria-hidden', 'true');
      var media = card.querySelector('.kkchat__card-media');
      if (media) media.appendChild(tag);
    }
  }
  function quickAdd(p, button) {
    if (button.classList.contains('is-busy')) return;
    button.classList.add('is-busy');
    if (p.single_variant) {
      button.disabled = true;
      addToBag({ variant_id: p.single_variant, quantity: 1 }, convo).then(function (res) {
        button.disabled = false;
        if (res.ok) cardAdded(button); else button.classList.remove('is-busy');
        showBagFact(res);
      }).catch(function () { button.disabled = false; button.classList.remove('is-busy'); showBagFact({ ok: false }); });
      return;
    }
    var handle = String(p.url || '').split('/products/')[1];
    if (!handle) { location.href = safePath(p.url); return; }
    handle = handle.split('?')[0];
    button.disabled = true;
    fetch(ROOT + '/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (d) {
      button.disabled = false;
      var item = {
        handle: d.handle, title: String(d.title).split('|')[0].trim(), url: '/products/' + d.handle,
        price: money(d.price), was: d.compare_at_price > d.price ? money(d.compare_at_price) : null,
        image: p.image, in_stock: !!d.available,
        variants: (d.variants || []).map(function (v) { return { id: v.id, title: v.public_title || v.title, in_stock: !!v.available }; }),
      };
      var entry = { k: 'product', item: item };
      var picker = add(renderEntry(entry));
      record(entry);
      button.classList.remove('is-busy');
      picker.__kkCardButton = button;                 // a choice made below marks the card above
      reveal(picker);
    }).catch(function () { button.disabled = false; button.classList.remove('is-busy'); location.href = safePath(p.url); });
  }

  /* ============ the list of conversations ============ */
  // what was said last in a chat, in a line
  function lastLine(c) {
    for (var i = c.log.length - 1; i >= 0; i--) {
      var e = c.log[i];
      if (e.k === 'bot' && e.text) return String(e.text).replace(/\*\*/g, '').replace(/\s+/g, ' ').trim();
      if (e.k === 'me' && e.text) return 'You: ' + String(e.text).replace(/\s+/g, ' ').trim();
      if (e.k === 'products') return (e.items || []).length + ' pieces shown';
      if (e.k === 'fact' && e.label) return e.label;
      if (e.k === 'ticket' && e.ticket) return 'Ticket ' + e.ticket.number + ' · ' + e.ticket.status;
    }
    return '';
  }
  function convoRow(c) {
    var li = make('li');
    var b = make('button', 'kkchat__convo');
    b.type = 'button';
    if (convo && c.id === convo.id) b.setAttribute('aria-current', 'true');
    b.appendChild(avatarNode());
    var text = make('span', 'kkchat__convo-text');
    var top = make('span', 'kkchat__convo-top');
    top.appendChild(make('span', 'kkchat__convo-title', c.title || 'New chat'));
    top.appendChild(make('span', 'kkchat__convo-when', when(c.updated)));
    text.appendChild(top);
    var last = lastLine(c);
    if (last) text.appendChild(make('span', 'kkchat__convo-last', last));
    b.appendChild(text);
    b.addEventListener('click', function () {
      if (busy) { announce('Please wait for the reply to finish.'); return; }
      convo = c; store.current = c.id; save(); renderConvo(); showLog(); el.input.focus({ preventScroll: true });
    });
    li.appendChild(b);
    return li;
  }
  function showList() {
    el.convoList.textContent = '';
    var list = kept();
    if (!list.length) {
      var empty = make('li', 'kkchat__empty');
      empty.appendChild(make('strong', null, 'No chats yet'));
      empty.appendChild(make('span', null, 'Ask about a piece, your size, delivery or an order — your chats will be kept here.'));
      el.convoList.appendChild(empty);
    }
    list.forEach(function (c) { el.convoList.appendChild(convoRow(c)); });
    el.clear.hidden = !list.length;
    unconfirm();
    el.convos.hidden = false;
    el.back.hidden = false;
    root.classList.add('is-inbox');
    el.title.textContent = 'Your chats';
    var first = el.convos.querySelector('button');
    if (first) first.focus({ preventScroll: true });
  }
  function showLog() {
    el.convos.hidden = true;
    el.back.hidden = true;
    root.classList.remove('is-inbox');
    el.title.textContent = config.title || 'KAARKASH';
    showRecent();
  }
  // On the welcome, the latest other chats, so the list of them is never out of sight.
  function showRecent() {
    // the customer's own tickets, first among the suggestions: one tap asks for the status
    var starters = root.querySelector('[data-kkchat-starters]');
    if (starters) {
      Array.prototype.slice.call(starters.querySelectorAll('[data-kkchat-ticket]')).forEach(function (n) { n.remove(); });
      savedTickets().slice(0, 2).reverse().forEach(function (t) {
        var b = make('button', 'kkchat__chip kkchat__chip--ticket', 'Status of ' + t.number);
        b.type = 'button';
        b.setAttribute('data-kkchat-ticket', '');
        b.setAttribute('data-kkchat-say', 'What is the status of my ticket ' + t.number + '?');
        starters.insertBefore(b, starters.firstChild);
      });
    }
    if (!el.recent) return;
    el.recentList.textContent = '';
    var others = kept().filter(function (c) { return !convo || c.id !== convo.id; }).slice(0, 2);
    others.forEach(function (c) { el.recentList.appendChild(convoRow(c)); });
    el.recent.hidden = !others.length;
  }
  // Clearing every chat asks once more first.
  function unconfirm() {
    if (!el.clear) return;
    el.clear.classList.remove('is-confirming');
    el.clear.textContent = 'Clear all chats';
  }
  function when(ts) {
    var d = new Date(ts), now = new Date();
    var time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    if (d.toDateString() === now.toDateString()) return 'Today, ' + time;
    var y = new Date(now); y.setDate(now.getDate() - 1);
    if (d.toDateString() === y.toDateString()) return 'Yesterday, ' + time;
    return d.toLocaleDateString([], { day: 'numeric', month: 'short' });
  }
  function startNew() {
    if (busy) return;
    if (convo && !convo.log.length) { showLog(); el.input.focus({ preventScroll: true }); return; }
    convo = newConvo();
    save();
    renderConvo();
    showLog();
    el.input.focus({ preventScroll: true });
  }

  /* ============ the input ============ */
  function sizeInput() {
    el.input.style.height = 'auto';
    el.input.style.height = Math.min(120, el.input.scrollHeight) + 'px';
    syncSend();
  }
  function syncSend() { el.send.disabled = busy || !el.input.value.trim(); }

  /* ============ staying out of the way ============ */
  // The button steps aside while a drawer, a menu or a sheet is open, and rises above a
  // sticky bar at the foot of a product page.
  function away() {
    var cd = document.querySelector('cart-drawer');
    // only 'active': Dawn adds 'animate' with it on opening but never takes it away, so a
    // test for 'animate' kept the button hidden, after the cart was first opened, until a reload
    var cartOpen = cd && cd.classList.contains('active');
    var locked = /overflow-hidden/.test(document.body.className);
    var menus = /(kkmn|kkn|kksr|kkc)-is-open/.test(html.className);
    var sheet = document.querySelector('.kkq.is-open');
    root.classList.toggle('is-away', !!(cartOpen || locked || menus || sheet || overButtons()) && !root.classList.contains('is-open'));
    var bar = document.querySelector('.psatc.is-visible');
    var lift = 0;
    // its height as well as where it is: when its class changes it is still sliding in from
    // below the window, and where it is then would leave the button on top of it
    if (bar && getComputedStyle(bar).display !== 'none') lift = Math.max(bar.offsetHeight, window.innerHeight - bar.getBoundingClientRect().top);
    root.style.setProperty('--kc-lift', lift ? (lift + 8) + 'px' : '0px');
  }
  // The button steps aside while it would sit on something a page asks it not to cover
  // ([data-kkchat-avoid]: the product page's cart button and heart).
  function overButtons() {
    var launcher = root.querySelector('.kkchat__launch');
    var avoid = document.querySelectorAll('[data-kkchat-avoid]');
    if (!launcher || !avoid.length) return false;
    var a = launcher.getBoundingClientRect();
    if (!a.width) return false;
    // where it stands, not where stepping aside has moved it (10px down: kk-chat.css); once
    // aside it comes back only when clear by 18px, so a measure taken mid-step cannot flicker it
    var away = root.classList.contains('is-away');
    var shift = away ? 10 : 0, room = away ? 18 : 8;
    var top = a.top - shift, bottom = a.bottom - shift;
    for (var i = 0; i < avoid.length; i++) {
      var b = avoid[i].getBoundingClientRect();
      if (b.width && a.left < b.right && a.right > b.left && top < b.bottom + room && bottom > b.top - room) return true;
    }
    return false;
  }
  var awayFrame = 0;
  function awaySoon() { if (!awayFrame) awayFrame = requestAnimationFrame(function () { awayFrame = 0; away(); }); }

  /* ============ events ============ */
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) { /* analytics never breaks the chat */ }
  }
  el.launch.addEventListener('click', open);
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-kkchat-close], [data-kkchat-new], [data-kkchat-list], [data-kkchat-back], [data-kkchat-say], [data-kkchat-track], [data-kkchat-clear]') : null;
    if (!t) return;
    if (t.hasAttribute('data-kkchat-clear')) {
      if (!t.classList.contains('is-confirming')) { t.classList.add('is-confirming'); t.textContent = 'Tap again to clear every chat'; return; }
      clearAll();
      return;
    }
    if (t.hasAttribute('data-kkchat-close')) close();
    else if (t.hasAttribute('data-kkchat-new')) startNew();
    else if (t.hasAttribute('data-kkchat-list')) { if (el.convos.hidden) showList(); else showLog(); }
    else if (t.hasAttribute('data-kkchat-back')) { showLog(); el.input.focus({ preventScroll: true }); }
    else if (t.hasAttribute('data-kkchat-say')) say(t.getAttribute('data-kkchat-say'));
    else if (t.hasAttribute('data-kkchat-track')) trackForm();
  });
  // WhatsApp one tap away (the header glyph, the quick tap): the message names the page they are on
  Array.prototype.slice.call(root.querySelectorAll('[data-kkchat-wa]')).forEach(function (a) {
    var l = fallbackLinks('Hi KAARKASH, I need help' + (config.pageTitle ? ' with ' + config.pageTitle : '') + '.');
    if (l.whatsapp) a.href = l.whatsapp;
    a.addEventListener('click', function () { track('kk_chat_handoff', { channel: 'whatsapp', from: 'tap' }); });
  });
  el.form.addEventListener('submit', function (e) { e.preventDefault(); say(el.input.value); });
  el.log.addEventListener('scroll', function () {
    if (ourScroll) return;
    follow = el.log.scrollHeight - el.log.scrollTop - el.log.clientHeight < 48;
  }, { passive: true });
  el.input.addEventListener('input', sizeInput);
  el.input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); say(el.input.value); }
  });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      // Escape belongs to whatever is on top: the cart drawer or a menu opened over the
      // chat closes first, and only then the chat.
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.classList.contains('active')) return;
      if (!el.panel.contains(document.activeElement) && document.activeElement !== document.body) return;
      e.preventDefault();
      if (!el.convos.hidden) showLog(); else close();
      return;
    }
    // on a phone the chat is the whole screen: the keyboard stays in it
    if (e.key !== 'Tab' || !phone.matches) return;
    var list = Array.prototype.slice.call(el.panel.querySelectorAll('a[href], button:not([disabled]), textarea')).filter(function (n) { return n.getClientRects().length; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], at = document.activeElement;
    if (list.indexOf(at) === -1) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && at === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
  });
  if ('MutationObserver' in window) {
    var watch = new MutationObserver(awaySoon);
    watch.observe(html, { attributes: true, attributeFilter: ['class'] });
    watch.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var cd = document.querySelector('cart-drawer');
    if (cd) watch.observe(cd, { attributes: true, attributeFilter: ['class'] });
    var bar = document.querySelector('.psatc');
    if (bar) watch.observe(bar, { attributes: true, attributeFilter: ['class'] });
  }
  window.addEventListener('resize', awaySoon);
  window.addEventListener('scroll', awaySoon, { passive: true });
  document.addEventListener('click', function () { setTimeout(awaySoon, 80); }, true);

  root.hidden = false;
  countChats();
  away();
  // A conversation left open elsewhere on the site is picked up where it was.
  window.__kkChat = { open: open, close: close, say: function (t) { open(); say(t); } };
})();
